import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-fct-integration',
	templateUrl: './fct.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FctIntegrationComponent {
	benefits = [
		'Save time and reduce errors by leveraging existing data within Closer to prepopulate the majority of your electronic order',
		'Receive automated updates regarding the state of your order',
		'Request quick quotes on premiums',
		'Automatically download title insurance documents and fees directly to your files in Closer',
	];
}
